/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AppVersionCreate,
  AppVersionDelete,
  AppVersionOnAzure,
  AppVersionUpdate,
} from '../models/index';
import {
    AppVersionCreateFromJSON,
    AppVersionCreateToJSON,
    AppVersionDeleteFromJSON,
    AppVersionDeleteToJSON,
    AppVersionOnAzureFromJSON,
    AppVersionOnAzureToJSON,
    AppVersionUpdateFromJSON,
    AppVersionUpdateToJSON,
} from '../models/index';

export interface ApiAppVersionActuallyGetAllByObjectTypeGetRequest {
    objectType?: string;
}

export interface ApiAppVersionAddPostRequest {
    appVersionCreate?: AppVersionCreate;
}

export interface ApiAppVersionDeleteDeleteRequest {
    appVersionDelete?: AppVersionDelete;
}

export interface ApiAppVersionGetAllByObjectTypeGetRequest {
    objectType?: string;
}

export interface ApiAppVersionGetAllLiveByObjectTypeGetRequest {
    objectType?: string;
}

export interface ApiAppVersionUpdatePutRequest {
    appVersionUpdate?: AppVersionUpdate;
}

/**
 * 
 */
export class AppVersionApi extends runtime.BaseAPI {

    /**
     */
    async apiAppVersionActuallyGetAllByObjectTypeGetRaw(requestParameters: ApiAppVersionActuallyGetAllByObjectTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppVersionOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['objectType'] != null) {
            queryParameters['object_type'] = requestParameters['objectType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/AppVersion/ActuallyGetAllByObjectType`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppVersionOnAzureFromJSON));
    }

    /**
     */
    async apiAppVersionActuallyGetAllByObjectTypeGet(requestParameters: ApiAppVersionActuallyGetAllByObjectTypeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppVersionOnAzure>> {
        const response = await this.apiAppVersionActuallyGetAllByObjectTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiAppVersionAddPostRaw(requestParameters: ApiAppVersionAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AppVersionOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/AppVersion/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AppVersionCreateToJSON(requestParameters['appVersionCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AppVersionOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiAppVersionAddPost(requestParameters: ApiAppVersionAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AppVersionOnAzure> {
        const response = await this.apiAppVersionAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiAppVersionDeleteDeleteRaw(requestParameters: ApiAppVersionDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/AppVersion/Delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: AppVersionDeleteToJSON(requestParameters['appVersionDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAppVersionDeleteDelete(requestParameters: ApiAppVersionDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAppVersionDeleteDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiAppVersionGetAllByObjectTypeGetRaw(requestParameters: ApiAppVersionGetAllByObjectTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppVersionOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['objectType'] != null) {
            queryParameters['object_type'] = requestParameters['objectType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/AppVersion/GetAllByObjectType`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppVersionOnAzureFromJSON));
    }

    /**
     */
    async apiAppVersionGetAllByObjectTypeGet(requestParameters: ApiAppVersionGetAllByObjectTypeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppVersionOnAzure>> {
        const response = await this.apiAppVersionGetAllByObjectTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiAppVersionGetAllLiveByObjectTypeGetRaw(requestParameters: ApiAppVersionGetAllLiveByObjectTypeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AppVersionOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['objectType'] != null) {
            queryParameters['object_type'] = requestParameters['objectType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/AppVersion/GetAllLiveByObjectType`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AppVersionOnAzureFromJSON));
    }

    /**
     */
    async apiAppVersionGetAllLiveByObjectTypeGet(requestParameters: ApiAppVersionGetAllLiveByObjectTypeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AppVersionOnAzure>> {
        const response = await this.apiAppVersionGetAllLiveByObjectTypeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiAppVersionUpdatePutRaw(requestParameters: ApiAppVersionUpdatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/AppVersion/Update`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AppVersionUpdateToJSON(requestParameters['appVersionUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiAppVersionUpdatePut(requestParameters: ApiAppVersionUpdatePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAppVersionUpdatePutRaw(requestParameters, initOverrides);
    }

}
